import { useEffect } from 'react';
import useHttp from '../../../../../hooks/use-http';
import OInput from '../../../../UI/FormControls/OInput';
import TextArea from '../../../../UI/FormControls/TextArea';
import OAutocomplete from '../../../../UI/MuiAutocomplete';
import { urls } from '../api/urls';
import DragAndDrop from '../../../../UI/DragAndDrop';

const Inputs = ({
  formValue,
  setFormValue,
  idRn,
  file,
  setFile,
  handleUkloniFile,
  naplacujeSe,
}) => {
  const { sendRequest: getVrstaUsluge, data: vrstaUslugeData } = useHttp('');
  const shouldShowField = localStorage.sa === 'true';
  useEffect(() => {
    if (idRn > 0) {
      getVrstaUsluge({
        url: urls.GET_VRSTE_USLUGE,
        method: 'POST',
        data: { id: idRn },
      });
    }
  }, []);

  const handleChange = (item) => {
    setFormValue((curr) => {
      return { ...curr, [item.target.name]: item.target.value };
    });
  };

  const handleClickVrstaUsluge = (item) => {
    setFormValue((curr) => {
      return {
        ...curr,
        idVrstaUsluge: item.id,
        nazivUsluge: item.vrednost,
        jm: item.jm,
        cena: item.cena,
      };
    });
  };
  const handleFiles = (files) => {
    setFormValue((curr) => {
      return { ...curr, nazivFajla: files[0].name };
    });
    setFile(files);
  };
  return (
    <div>
      {' '}
      <OAutocomplete
        data={vrstaUslugeData}
        value={formValue.nazivUsluge}
        handleClick={handleClickVrstaUsluge}
        label="Vrsta usluge"
        style={{ width: '100%' }}
        touched={formValue.touchedNazivUsluge}
        setTouched={() => {
          setFormValue((curr) => {
            return { ...curr, touchedNazivUsluge: true };
          });
        }}
        errorMessage="Vrsta usluge je obavezno polje"
      />
      {/* <OInput
        label="Naziv"
        name="naziv"
        value={formValue.naziv}
        handleChange={handleChange}
        style={{ width: '100%' }}
      /> */}
      <OInput
        label="Jedinica mere"
        name="jm"
        value={formValue.jm}
        handleChange={handleChange}
        style={{ width: '100%' }}
        // disabled
      />
      <OInput
        label="Količina"
        name="kolicina"
        value={formValue.kolicina}
        handleChange={handleChange}
        style={{ width: '100%' }}
        type="number"
      />
      <OInput
        label="Cena koštanja"
        name="cena"
        value={formValue.cena}
        handleChange={handleChange}
        style={{ width: '100%', block: 'none' }}
        type="number"
      />
      <OInput
        label="Cena prema klijentu"
        name="iznos"
        value={formValue.iznos}
        handleChange={handleChange}
        style={{
          width: '100%',
          display: shouldShowField && naplacujeSe ? 'block' : 'none',
        }}
        type="number"
      />
      <TextArea
        label="Opis"
        rows="4"
        name="opis"
        value={formValue.opis}
        handleChange={handleChange}
        style={{ width: '100%', height: '100px' }}
      />
      <DragAndDrop
        handleFiles={handleFiles}
        maxFiles={5}
        addedFiles={file}
        handleRemoveFile={handleUkloniFile}
      />
    </div>
  );
};

export default Inputs;
